import { ActivationType, RegistrationType, VerificationType } from 'shared/dataLayer';
import { DataLayerVariable } from './dataLayerVariables';

export enum DataLayerEventList {
	NotVerifiedPlayerSurvey = 'not-verified-player-survey',
	PromotionChosenWhileRegistering = 'promotion-chosen-while-registering',
	BetError = 'bet_error',
	BetSuccess = 'bet_success',
	DepositFalse = 'deposit-false',
	RegStart2 = 'reg_start2',
	HomePageBannerClick = 'hp_banner_click',
	DepoStart = 'depo_start',
	RegStart = 'reg_start',
	RegOpen = 'reg_open',
	RegFailed = 'reg_failed',
	RegSuccess = 'reg_success',
	VerOpen = 'ver_open',
	VerStart = 'ver_start',
	VerSuccess = 'ver_success',
	VerFailed = 'ver_failed',
}

export type DataLayerEventParamsMap = {
	[DataLayerEventList.NotVerifiedPlayerSurvey]: undefined;
	[DataLayerEventList.PromotionChosenWhileRegistering]: {
		[DataLayerVariable.RegistrationPromotionId]: string;
		[DataLayerVariable.RegistrationPromotionName]: string;
	};
	[DataLayerEventList.BetError]: { [DataLayerVariable.BetErrorCodes]: string[] };
	[DataLayerEventList.BetSuccess]: {
		[DataLayerVariable.IsPremadeBetbuilder]: boolean;
		[DataLayerVariable.BalanceBeforeCoupon]: number;
		[DataLayerVariable.BalanceAfterCoupon]: number;
		[DataLayerVariable.BetBonusBalance]?: number;
		[DataLayerVariable.BetBalanceType]: string;
		[DataLayerVariable.CouponType]: string;
		[DataLayerVariable.StakeMethod]: string;
		[DataLayerVariable.BetValue]: number;
		[DataLayerVariable.OriginUrl]: string;
		[DataLayerVariable.TotalEvents]: number;
		[DataLayerVariable.TotalEventsRemoved]: number;
		[DataLayerVariable.BetPotentialWin]: string | number;
		[DataLayerVariable.BetType]: string | number;
		[DataLayerVariable.TotalOdds]: number;
		[DataLayerVariable.CouponEvents]?: {
			action_at: number;
			action_id: string;
			action_type: 'add' | 'remove';
			action_data: 'add' | 'remove';
		}[];
		[DataLayerVariable.CouponEventsRemoved]?: {
			action_at: number;
			action_id: string;
			action_type: 'add' | 'remove';
			action_data: 'add' | 'remove';
		}[];
		[DataLayerVariable.SessionId]?: string;
		[DataLayerVariable.FreebetName]?: string;
		[DataLayerVariable.BonusName]?: string;
	};

	[DataLayerEventList.DepositFalse]: {
		[DataLayerVariable.DepositValue]: number;
	};
	[DataLayerEventList.DepoStart]: { [DataLayerVariable.DepositOrigin]: ('panel gracza' | 'nawigacja')[] };
	[DataLayerEventList.RegStart]: {
		[DataLayerVariable.RegType]: RegistrationType;
	};
	[DataLayerEventList.RegOpen]: {
		[DataLayerVariable.CurrentPage]: string;
	};
	[DataLayerEventList.RegFailed]: {
		[DataLayerVariable.FailReason]: string;
		[DataLayerVariable.RegType]: RegistrationType;
	};
	[DataLayerEventList.RegSuccess]: {
		[DataLayerVariable.RegType]: RegistrationType;
		[DataLayerVariable.ActivationType]?: ActivationType;
	};
	[DataLayerEventList.VerOpen]: {
		[DataLayerVariable.CurrentPage]: string;
	};
	[DataLayerEventList.VerStart]: {
		[DataLayerVariable.VerType]: VerificationType;
	};
	[DataLayerEventList.VerSuccess]: {
		[DataLayerVariable.VerType]: VerificationType;
	};
	[DataLayerEventList.VerFailed]: {
		[DataLayerVariable.VerType]: VerificationType;
		[DataLayerVariable.FailReason]: string;
	};
	[DataLayerEventList.RegStart2]: {
		[DataLayerVariable.RegAlt]?: string;
	};
	[DataLayerEventList.HomePageBannerClick]: {
		[DataLayerVariable.HpBannerImageAlt]: string;
		[DataLayerVariable.HpBannerPosition]: number[];
	};
};
